<ng-dialog-header [title]="data ? ('Report Details: RPT' + data.id + ' '+data.name) : 'Report Details'"></ng-dialog-header>
<div class="align-self-stretch overflow-auto d-flex flex-column h-100" mat-dialog-content>
  <mat-tab-group class="ns-mat-tab-group h-100 overflow-auto">
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon fontSet="fas" fontIcon="fa-info" class="mr-1 h-auto"></mat-icon>
        Information
      </ng-template>
      <ng-template matTabContent>
        <ng-report-details-information [data]="data"></ng-report-details-information>
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon fontSet="fas" fontIcon="fa-users" class="mr-1 h-auto"></mat-icon>
        Recipients
      </ng-template>
      <ng-template matTabContent>
        <ng-report-recipients [recipients]="data?.recipients || []"></ng-report-recipients>
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon fontSet="fas" fontIcon="fa-table" class="mr-1 h-auto"></mat-icon>
        Columns
      </ng-template>
      <ng-template matTabContent>
        <ng-report-information-filters [tabs]="data?.tabs || []" [config]="{ displayHeaders: false }"></ng-report-information-filters>
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon fontSet="fas" fontIcon="fa-clock" class="mr-1 h-auto"></mat-icon>
        Schedule
      </ng-template>
      <ng-template matTabContent>
        <ng-report-details-schedule [schedule]="data?.schedule"></ng-report-details-schedule>
      </ng-template>
    </mat-tab>
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon fontSet="fas" fontIcon="fa-history" class="mr-1 h-auto"></mat-icon>
        Execution History
      </ng-template>
      <ng-template matTabContent>
        <ng-report-details-execution [historyExecutions]="data?.historyExecutions || []"></ng-report-details-execution>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
<ng-dialog-footer>
  <div class="d-flex justify-content-end w-100" dialog-actions>
    <button mat-stroked-button color="warn" aria-label="Close Button" mat-dialog-close>
      Close
    </button>
  </div>
</ng-dialog-footer>
